.media-default-skin .media-badge {
  padding: calc(var(--media-spacing) * 0.5) calc(var(--media-spacing) * 1.5);
  font-size: var(--media-font-size-small);
  font-weight: 500;
  line-height: 1;
  color: oklch(from currentColor l c h / 0.85);
  white-space: nowrap;
  background-color: oklch(from currentColor l c h / 0.1);
  border-radius: calc(Infinity * 1px);
}
